import React, { useState } from "react";
import { Document, Page } from "react-pdf";
import { DocumentCallback } from "react-pdf/src/shared/types.js";
import LoadingIndicator from "../loading/LoadingIndicator";

interface Props {
  file: string;
  getDocument?: (document: Blob) => void;
}

const PdfViewer: React.FC<Props> = (props): React.ReactElement => {
  const { file, getDocument } = props;

  const [numPages, setNumPages] = useState<number>(0);

  const onLoad = async (pdf: DocumentCallback) => {
    if (getDocument) {
      const data = await pdf.getData();
      const blob = new Blob([data], { type: "application/pdf" });

      getDocument(blob);
    }

    setNumPages(pdf.numPages);
  };

  const renderPages = () => {
    const pages = [];

    for (let index = 1; index <= numPages; index++) {
      pages.push(
        <Page
          loading={<LoadingIndicator />}
          pageNumber={index}
          width={920}
          scale={1.75}
          className="PdfViewer_page"
          key={index}
        />,
      );
    }

    return pages;
  };

  //   const options = useMemo(
  //     () => ({ httpHeaders: { Authorization: `Bearer ${getAccessToken()}` } }),
  //     [],
  //   );

  return (
    <Document
      file={file}
      onLoadSuccess={onLoad}
      //   options={options}
      loading={<LoadingIndicator />}
      className="PdfViewer"

      //   error={
      //     <ErrorAlert
      //       errorCode="errors.loadDocumentFailed"
      //       onRetry={() => location.reload()}
      //     />
      //   }
      //   onLoadError={(error) => Sentry.captureException(error)}
    >
      {renderPages()}
    </Document>
  );
};

export default PdfViewer;
